import Vue from 'vue';
import VueI18n from 'vue-i18n';
import env from '@/env';
import loadLocaleMessages from './loadLocaleMessages';

Vue.use(VueI18n);

export default new VueI18n({
  locale: env.I18N_LOCALE || 'en-US',
  fallbackLocale: env.I18N_FALLBACK_LOCALE || 'en-US',
  messages: loadLocaleMessages(),
});
